.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1-5);
  min-width: 0;
}

.label {
  color: var(--color-fg);
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  user-select: none;
}

.input {
  width: 100%;
  min-width: 0;
  height: var(--size-control);
  padding: 0 var(--space-2-5);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-md);
  background: var(--color-surface);
  color: var(--color-fg);
  font-size: var(--text-base);
  transition: border-color var(--duration-fast) var(--ease-standard);
}

.input::placeholder {
  color: var(--color-fg-subtle);
}

.input:focus-visible {
  border-color: var(--color-focus);
  outline-offset: 0;
}

.input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.input[aria-invalid="true"] {
  border-color: var(--color-fail);
}

.textarea {
  height: auto;
  min-height: calc(var(--size-control) * 2.5);
  padding: var(--space-2) var(--space-2-5);
  resize: vertical;
  line-height: var(--lh-base);
}

.description {
  color: var(--color-fg-muted);
  font-size: var(--text-sm);
}

.error {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  color: var(--color-fail);
  font-size: var(--text-sm);
}

.error svg {
  width: var(--size-icon-sm);
  height: var(--size-icon-sm);
  flex-shrink: 0;
}
